<ion-avatar *ngIf="photoURL">
  <img [src]="photoURL" />
</ion-avatar>

<div *ngIf="!photoURL && name" class="circle">
  <h2>{{ name.charAt(0) }}</h2>
</div>

<ion-icon *ngIf="!photoURL && !name" src="/assets/icons/24px/member-2.svg"></ion-icon>
